var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"msg_box error"},[_c('h3',[_vm._v("ご入力内容にエラー項目があります")]),_c('p',[_vm._v("エラー個所は赤く表示され、エラー理由がすぐ下に赤字で示されます。"),_c('br'),_vm._v("お手数ですが、エラー項目を修正してからボタンを押してください。")])])
}]

export { render, staticRenderFns }